import { HandCoinsIcon } from "lucide-react"
import { useTranslation } from "react-i18next"

import { AppPagination } from "@/components/commons/app-pagination"
import { AppSkeletonTable } from "@/components/commons/app-skeleton-table"
import { DataTable } from "@/components/ui/data-table"
import {
  useDefaulterSearchParams,
  useDefaultersOrder,
} from "@/hooks"

import { DefaultersDownload } from "./download"
import { createDefaultersOrderColumns } from "./order-columns"
export const DefaultersRotateTable = () => {
  const { t } = useTranslation()
  const { params } = useDefaulterSearchParams()
  const refetch =
    params.tab === "rotate" && params.refetch === "true"
  const { data, isFetching } = useDefaultersOrder(
    params,
    refetch
  )
  if (isFetching) {
    return (
      <AppSkeletonTable
        withHeaderButton
        withAction
        columns={7}
      />
    )
  }
  const total = data?.defaulterOrderList?.length || 0
  const pagination = {
    currentPage: params.page,
    total,
    totalPages: Math.ceil(total / params.quantity),
    startPage: 0,
  }
  if (!refetch) {
    return (
      <div className="mt-4 flex flex-1 flex-col items-center justify-center gap-4 text-muted-foreground">
        <HandCoinsIcon size={48} strokeWidth={1.5} />
        <p className="text-center">
          Para visualizar transações de rotativo efetue uma
          busca.
        </p>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      <DataTable
        data={data?.defaulterOrderList}
        columns={createDefaultersOrderColumns(t)}
        showColumnVisibility
        actionChildren={<DefaultersDownload mode="order" />}
      />
      <AppPagination
        pagination={pagination}
        startPage={pagination.startPage}
      />
    </div>
  )
}
